
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/contact",
      function () {
        return require("private-next-pages/home/contact.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/contact"])
      });
    }
  